import { Component, computed, input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ImageUrlDirective } from "../../directives/image-url.directive";

/**
 * A shopper's picture or a product image on the Messages page: full URLs (a
 * Google profile photo, say) are shown as they are, storage paths through the
 * app's presigned-URL directive, and nothing at all as an icon.
 */
@Component({
  selector: "fh-chat-image",
  standalone: true,
  imports: [ImageUrlDirective, MatIconModule],
  template: `
    @if (!path()) {
      <mat-icon class="fallback">{{ fallbackIcon() }}</mat-icon>
    } @else if (isUrl()) {
      <img [src]="path()" [alt]="alt()" loading="lazy" referrerpolicy="no-referrer" />
    } @else {
      <img fhImageUrl [originalUrl]="path()!" [alt]="alt()" />
    }
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background-color: #eceff1;
        flex-shrink: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover !important;
        display: block;
      }
      .fallback {
        color: #90a4ae;
      }
    `,
  ],
})
export class ChatImageComponent {
  path = input<string | null | undefined>(null);
  alt = input<string>("");
  fallbackIcon = input<string>("person");

  isUrl = computed(() => /^https?:\/\//.test(this.path() ?? ""));
}
